import { render, staticRenderFns } from "./EditAlipay.vue?vue&type=template&id=2d59e1d1&"
import script from "./EditAlipay.vue?vue&type=script&lang=js&"
export * from "./EditAlipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports